import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-money-log-history'

const headers = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  'Authorization': token
})

export const getMoneyLogHistory = async (token, query, page) => {
  const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
    ...query,
    page,
  }, {
    headers: headers(token),
  })

  if (response && response.status === 200) {
    return response.data || {}
  }
  return {}
}
